import React from 'react';
import { Grid, CardHeader } from '@mui/material';

export type BlockProps = {
    title?: string;
    content: React.ReactNode;
};

export const Block = ({ title, content }: BlockProps) => {
    return (
        <Grid container maxWidth="672px" margin="0 auto">
            {!!title && (
                <Grid item sx={{ paddingLeft: 0 }}>
                    <CardHeader title={title} sx={{ paddingLeft: 0 }} />
                </Grid>
            )}
            <Grid container paddingLeft={2} paddingRight={2} spacing={2} margin={0} width="100%">
                {content}
            </Grid>
        </Grid>
    );
};
